<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems='contextMenuItems' :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :rowDeselected='getChoose' :rowSelecting='rowSelecting'>
      <e-columns :columns='shipColumns' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'>
        <e-column field='taskName' minWidth='10' :headerText='$t("Observe.taskName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskId' minWidth='10' :isPrimaryKey='true' :headerText='$t("Observe.taskID")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' minWidth='10' :headerText='$t("Observe.resourceName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='typeName' minWidth='10' :headerText='$t("Observe.resourceType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskStatus' minWidth='10' :headerText='$t("Observe.taskStatus")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='statusFormat'></e-column>
        <e-column field='createTimeStr' minWidth='10' :headerText='$t("Observe.creatTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sliceId' minWidth='10' :headerText='$t("Observe.sliceId")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sliceIdFormat'></e-column>
        <e-column field='reportLevel' minWidth='10' :headerText='$t("Observe.reportLevel")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='reportLevelFormat'></e-column>
        <e-column field='errorStr' minWidth='10' :headerText='$t("Observe.result")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getObserveListData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='addDialog'  :element="addDialog.element"
      :styles="addDialog.styles">
      <template v-slot:dialog-content>
        <AddObserveTask ref="addContent"></AddObserveTask>
      </template>
    </CustomDialog>
    <CustomDialog ref='detailDialog' :element='detailDialog.element' :styles='detailDialog.styles'>
      <template v-slot:dialog-content>
        <ObserveDetail ref='detailContent'></ObserveDetail>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../common/CustomDialog';
// import CustomDialog from '@/components/common/CustomDialog';
  import ObserveDetail from './ObserveDetail';
  import AddObserveTask from './AddObserveTask';
  import bus from '../bus.js';
  import { EventBus } from '../../../plugins/eventBus';
  import socketInstance from '../../../plugins/stompSock';

  const { mapGetters, mapActions } = createNamespacedHelpers('observeConfig');
  export default {
    name: 'observeTable',
    components: {
      CustomDialog,
      ObserveDetail,
      AddObserveTask
    },
    props: ['observeType'],
    data() {
      return {
        selectionOptions: { type: 'Single' },
        contextMenuItems: [
          { text: `${this.$t('Observe.activationTask')}` },
          { text: `${this.$t('Observe.suspendTask')}` },
          { text: `${this.$t('Observe.taskDeletion')}` },
          { text: `${this.$t('Observe.taskTracking')}` },
          { text: `${this.$t('Observe.taskDetails')}` }
        ],
        observeStatus: { // 配置不同状态对应的值
          issued: 0,
          greate: 1,
          tracing: 2,
          hangup: 3,
          delete: 4,
          finish: 5
        },
        queryConditions: {
          keywords: '' // 任务名称模糊查询关键字
        },
        currentNeInfo: '',
        data: [],
        primaryDatas: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          totalCount: 0,
          pageCount: 10
        },
        currentSelectDataId: '',


        addDialog: {
         element: {
            target: this.$refs.addContent,
            title: this.$t('Observe.createTask'),
            refName: 'addDialog',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Observe.cancel') } },
              { click: this.saveAddTask, buttonModel: { content: this.$t('Observe.confirm'), isPrimary: true } }
            ]
            },
         styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
        },
        detailDialog: {
          element: {        
            target: this.$refs.detailContent,
            refName: 'detailDialog',
            title: this.$t('Observe.taskDetails'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Observe.close')} }
            ]
        },
        styles: {
            width: '810px',
            height: '717px',
            model: true,
            visible: false
          }
        },     

        websocketSetting: [
          { topic: '/topic/#/ObserveTaskServer', clientId: 'observe', callback: this.websocketCallback }
        ],
        shipColumns: [
          {
            field: 'ShippedDate',
            headerText: 'Shipped Date',
            format: 'yMd',
            textAlign: 'Right',
            width: 150,
            minWidth: 10
          },
          {
            field: 'ShipCountry',
            headerText: 'Ship Country',
            width: 150,
            minWidth: 10
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['currentNe']),
      ...mapGetters(['neVisionList']),
      ...mapGetters(['resourceIdList'])
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    methods: {
      ...mapActions(['setCurrentNe']),
      statusFormat(grids, data) {
        const { taskStatus } = data;
        switch (taskStatus) {
          case this.observeStatus.issued:
            return `<span style='color:blue;'>${this.$t('Observe.issued')}</span>`;
          case this.observeStatus.greate:
            return `<span style='color:blue;'>${this.$t('Observe.greate')}</span>`;
          case this.observeStatus.tracing:
            return `<span style='color:green;'>${this.$t('Observe.tracing')}</span>`;
          case this.observeStatus.hangup:
            return `<span style='color:red;'>${this.$t('Observe.hangup')}</span>`;
          case this.observeStatus.delete:
            return `<span>${this.$t('Observe.delete')}</span>`;
          case this.observeStatus.finish:
            return `<span style='color:orange;'>${this.$t('Observe.finish')}</span>`;
          default:
            return taskStatus;
        }
      },
      reportLevelFormat(grids, data) {
      if (null!==data && undefined!==data && data.reportLevel === 1) {
        return this.$t('Observe.reportError');
      }
      else if (null!==data && undefined!==data && data.reportLevel === 2) {
        return this.$t('Observe.reportWarning');
      }else{
      return this.$t('Observe.reportInfo');
      }
    },
      sliceIdFormat(grids, data) {
      if (null!==data && undefined!==data && (data.typeCode===43||data.typeCode===44||data.typeCode===45||data.typeCode===46||data.typeCode===47||data.typeCode===48)&&data.sliceId === 0) {
        return "";
      }
      else
      return data.sliceId
    },
      resultFormat(grids, data) {
        if (data.errorCode === 0) {
          return this.$t('Observe.success');
        } else if (data.errorCode === 1) {
          return this.$t('Observe.autoActivationFailed');
        }
        return this.$t('Observe.error');
      },
      rowSelecting(args){
        if (args.target.innerHTML === this.$t('Observe.reIssued')) {
          this.currentSelectDataId = args.data.taskId;
          this.reSaveFunc(args.data);
        }
      },
      getChoose(args) {
        if (args.target.innerHTML === this.$t('Observe.reIssued') && args.isInteracted === true) {
          if (args.name === 'rowDeselected' && args.data.length > 0) {
            if (args.data[0].taskId === this.currentSelectDataId) {
              this.reSaveFunc(args.data[0]);
            }
          }
        }
      },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
          return;
        }
        const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
        childList.forEach(elem => {
          elem.style.display = 'block';
        });
        switch (this.getCheckedVals().taskStatus) {
          case this.observeStatus.greate: break;
          case this.observeStatus.tracing: // 正在执行时不显示激活选项
            childList[0].style.display = 'none';
            break;
          case this.observeStatus.hangup: // 挂起时不显示挂起选项
            childList[1].style.display = 'none';
            break;
          case this.observeStatus.delete: break;
          case this.observeStatus.finish: break;
          default:
        }
      },
      menuClickFunc(menuArgs) { // 为右键分配事件
        switch (menuArgs.element.innerText) {
          case `${this.$t('Observe.activationTask')}`:
            this.activeObservePage();
            break;
          case `${this.$t('Observe.suspendTask')}`:
            this.hangupObservePage();
            break;
          case `${this.$t('Observe.taskDeletion')}`:
            this.deleteObservePage();
            break;
          case `${this.$t('Observe.taskTracking')}`:
            this.missionObservePage();
            break;
          case `${this.$t('Observe.taskDetails')}`:
            this.detailObservePage();
            break;
          default:
        }
      },
      dialogHide() {
        this.$refs.addDialog
        this.$refs.addDialog.clear();
        this.$refs.addDialog.close();
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
      },
      websocketInit() {
        socketInstance.init(this.websocketSetting);
      },
      websocketCallback(msg) {
        console.log('ObserveTaskServer:>>>>>', msg);
        if (msg) {
          const data = JSON.parse(msg.body);
          const newData = this.data[this.data.findIndex(v => v.taskId === data.taskId)];
          newData.taskStatus = data.taskStatus;
          newData.endTime = data.endTime;
          newData.endTimeStr = data.endTimeStr;
          newData.errorStr = data.errorStr;
          this.$refs.grid.setRowData(data.taskId, newData);
        }
      },
      getCheckedData(selectOnly) {
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
          return false;
        }
        if (selectedRecords.length > 1 && !selectOnly) {
          EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.too_many_checked')}!`});
          return false;
        }
        return selectedRecords;
      },
      getCheckedVals() {
        const checkedData = this.getCheckedData(true);
        if (checkedData) {
          return checkedData[0];
        }
        return false;
      },
      getObserveListData() {
        // 获取表格数据
        const This = this;
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        const params = {
          observeType: `${this.observeType}`,
          neIdList: This.currentNeInfo ? [This.currentNeInfo.id] : this.resourceIdList,
          taskName: This.queryConditions.keywords ? This.queryConditions.keywords : '',
          pageNo: parseInt(This.page.pageNo, 10),
          pageSize: parseInt(This.page.pageSize, 10)
        };
        if (params.neIdList.length > 0) {
          This.$axios.post('/lte/ems/observe/queryObserve', params).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              const result = response.data.resultVal;
              This.page.totalCount = result.totalCount;
              This.data = result.result;
              This.primaryDatas = This.data;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        } else {
          This.data = [];
          This.primaryDatas = This.data;
        }
      },
      addObservePage() {
        if (!this.currentNeInfo) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.pleaseSelectNE')});
        } else {
          this.$refs.addContent.clear();
          this.$refs.addDialog.show();
          this.$refs.addContent.loadNeForm(this.currentNeInfo);
        }
      },
      saveAddTask() {
        const data = this.$refs.addContent.getFormData();
        if (data !== false) {
          data.observeType = this.observeType;
          this.dialogHide();
          this.$axios.post('/lte/ems/observe/createTask', data).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === '0') {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
              this.getObserveListData();
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
      },
      reSaveFunc(data) {
        this.$axios.post('/lte/ems/observe/createTask', JSON.parse(data.paramsJson)).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === '0') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.getObserveListData();
        });
      },
      saveTask() {
        const data = this.$refs.addContent.getFormData();
        if (data !== false) {
          data.observeType = this.observeType;
          this.$axios.post('/lte/ems/observe/preserveObserveTask', data).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === '0') {
              this.dialogHide();
              EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
              this.getObserveListData();
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
      },
      activeObservePage() {
        // 激活任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if (checkedData.taskStatus === this.observeStatus.tracing) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.taskInProgress')});
          } else {
            this.$axios.post(`/lte/ems/observe/activeTask/${checkedData.taskId}`).then((response) => {
              if (response && response.status === 200 && response.data.errorCode === '0') {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
                this.getObserveListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
          }
        }
      },
      hangupObservePage() {
        // 挂起任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if (checkedData.taskStatus === this.observeStatus.hangup) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.taskIsPending')});
          } else {
            this.$axios.post(`/lte/ems/observe/pauseTask/${checkedData.taskId}`).then((response) => {
              if (response && response.status === 200 && response.data.errorCode === '0') {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
                this.getObserveListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
          }
        }
      },
      finishObservePage() {
        // 完成任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if (checkedData.taskStatus === this.observeStatus.finish) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.missionAlreadyCompleted')});
          } else {
            this.$axios.post(`/lte/ems/observe/finishTask/${checkedData.taskId}`).then((response) => {
              if (response && response.status === 200 && response.data.errorCode === '0') {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
                this.getObserveListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
          }
        }
      },
      deleteObservePage() {
        // 删除任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          this.$layer.confirm({
            msg: this.$t('Observe.deleteTaskInfo'),
            btn1: { msg: this.$t('Observe.cancel') },
            btn2: {
              msg: this.$t('Observe.confirm'),
              func: () => {
                this.$axios.post(`/lte/ems/observe/deleteTask/${checkedData.taskId}`).then((response) => {
                  if (response && response.status === 200 && response.data.errorCode === '0') {
                    EventBus.$emit('toast', {type: 'success', content: this.$t('Observe.success')});
                    this.getObserveListData();
                  } else {
                    EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
                  }
                });
              }
            }
          });
        }
      },
      detailObservePage() {
        // 任务详情
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          this.$refs.detailDialog.show();
          this.$refs.detailContent.setObserveId(checkedData);
        }
      },
      missionObservePage() {
        // 任务跟踪
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          if (checkedDataList[0].taskStatus === this.observeStatus.hangup) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.taskIsPending')});
          } else if (checkedDataList[0].taskStatus === this.observeStatus.finish) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Observe.missionAlreadyCompleted')});
          } else {
            checkedDataList[0].oamTypeCode = this.neVisionList[checkedDataList[0].neId] ? this.neVisionList[checkedDataList[0].neId][1] : '';
            checkedDataList[0].directoryName = checkedDataList[0].taskId;
            checkedDataList[0].fileName = null;
            this.$emit('addTab', checkedDataList);
          }
        }
      },
      downloadObservePage() {
        // 下载文件
        const checkedDataList = this.getCheckedData(true);
        if (checkedDataList) {
          this.$axios.get(`/lte/ems/observe/checkTaskDirectory/${checkedDataList[0].taskId}`).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              const result = response.data.resultVal;
              checkedDataList[0].oamTypeCode = this.neVisionList[checkedDataList[0].neId] ? this.neVisionList[checkedDataList[0].neId][1] : '';
              checkedDataList[0].fileType = result;
              this.$emit('downloadTab', checkedDataList);
            } else {
              EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
            }
          });
        }
      }
    },
    mounted() {
      bus.$on('loadObserveTable', (neNode) => {
        this.currentNeInfo = neNode;
        this.queryConditions.keywords = '';
        this.page.pageNo = "1";
        this.$refs.pager.ej2Instances.currentPage = 1;
        this.getObserveListData();
        this.setCurrentNe(neNode);
        bus.$emit('curMoData');
      });
      bus.$on('refreshObserveTable', () => {
        this.getObserveListData();
      });
      this.websocketInit();
      // this.getObserveListData();
      setTimeout(this.websocketCallback, 5000);
    },
    beforeDestroy() {
      bus.$off('loadObserveTable');
      bus.$off('refreshObserveTable');
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[0].clientId, this.websocketSetting[0].topic);
    }
  };
</script>
